var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 1729",
    filter: "url(#filter0_d_241_3984)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 26,
    width: 102,
    height: 102,
    rx: 20,
    fill: "url(#paint0_linear_241_3984)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M117 76.436H111.514V77.5642H117V76.436Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M105.196 64H104.124V69.7734H105.196V64Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M105.196 84.2134H104.124V89.9867H105.196V84.2134Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M114.705 87.5048L115.461 86.7085L114.566 85.7927L106.204 76.9933L114.566 68.2072L113.809 67.4109L105.448 76.2103L104.691 76.9933L105.448 77.7897L113.544 86.3103L114.705 87.5048Z",
    fill: "url(#paint1_linear_241_3984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M108.123 67.5627L107.071 70.2358L107.49 70.4187L108.542 67.7456L108.123 67.5627Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M107.492 83.5822L107.073 83.7651L108.125 86.438L108.545 86.255L107.492 83.5822Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M48.8844 70.4238C48.9348 70.1052 49.0105 69.8398 49.0988 69.654C49.1871 69.4682 49.3006 69.2956 49.4267 69.1364C49.6285 68.8975 49.8807 68.6984 50.1834 68.5524C50.4861 68.4064 50.8392 68.3268 51.2302 68.3268C51.9743 68.3268 52.5544 68.5126 52.9706 68.8842C53.3868 69.2558 53.6894 69.8265 53.8534 70.5698L53.9038 70.8087H57.6495L57.5991 70.4503C57.4855 69.7071 57.2838 68.9904 56.9685 68.3135C56.6658 67.6366 56.237 67.0128 55.7199 66.4952C55.2028 65.9644 54.5596 65.5396 53.8156 65.2211C53.0715 64.9159 52.2013 64.7566 51.2302 64.7566C50.2969 64.7566 49.4393 64.9291 48.6952 65.2609C47.9511 65.5927 47.2701 66.0838 46.6774 66.7076C46.2486 67.1588 45.908 67.6499 45.681 68.1675C45.454 68.6719 45.2901 69.2293 45.1892 69.8133C45.1009 70.384 45.0378 71.0077 45.0252 71.6448C45.0126 72.2819 45 72.972 45 73.702C45 74.4319 45.0126 75.1221 45.0252 75.7591C45.0378 76.4095 45.1009 77.02 45.1892 77.5907C45.2901 78.1747 45.454 78.7321 45.681 79.2364C45.908 79.754 46.2486 80.2451 46.6774 80.6964C47.2701 81.3201 47.9637 81.8112 48.7078 82.143C49.4519 82.4748 50.3095 82.6474 51.2302 82.6474C52.1256 82.6474 52.9706 82.5014 53.7651 82.1961C54.5723 81.8908 55.3163 81.36 55.9974 80.6167C56.5901 79.9664 57.0063 79.2099 57.2585 78.3605C57.4982 77.5376 57.6243 76.4758 57.6243 75.2283V72.4411H50.9401V75.8255H53.9164V76.1706C53.9164 76.582 53.866 76.9669 53.7651 77.312C53.6642 77.6438 53.5003 77.9623 53.2733 78.241C53.0462 78.5065 52.7562 78.7188 52.4283 78.8648C52.0878 79.0108 51.6842 79.0904 51.2428 79.0904C50.8518 79.0904 50.4987 79.0241 50.196 78.8781C49.8933 78.7321 49.6411 78.5463 49.4393 78.3074C49.3132 78.1614 49.1997 77.9889 49.1114 77.7898C49.0231 77.604 48.9475 77.3385 48.897 77.02C48.8339 76.6882 48.7961 76.2502 48.7709 75.7193C48.7457 75.1884 48.7331 74.5116 48.7331 73.702C48.7331 72.8924 48.7457 72.2288 48.7709 71.6979C48.7835 71.1803 48.8339 70.7556 48.8844 70.4238Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M66.7927 73.6887L62.757 64.9026H59.1753V82.5146H62.9083V73.5693L65.5442 79.0506H68.0413L70.6519 73.5825V82.5146H74.385V64.9026H70.8033L66.7927 73.6887Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M87.6654 64.9026H75.4951V68.4728H79.72V82.5146H83.4531V68.4728H87.6654V64.9026Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M93.3784 76.1838C93.5171 75.998 93.6432 75.7989 93.7315 75.5998C93.8198 75.4008 93.8955 75.2017 93.9459 74.9893C93.9964 74.777 94.0216 74.5381 94.0216 74.2726C94.0216 73.7816 93.9459 73.3303 93.782 72.9322C93.6306 72.534 93.4036 72.2022 93.1262 71.9235C92.8487 71.6448 92.5082 71.4324 92.1172 71.2864C91.7263 71.1404 91.2975 71.0608 90.8308 71.0608C90.3768 71.0608 89.9606 71.1272 89.5696 71.2731C89.1787 71.4191 88.8382 71.6315 88.5481 71.9102C88.258 72.1889 88.031 72.534 87.8671 72.9322C87.7031 73.3303 87.6274 73.7816 87.6274 74.2859H89.5444C89.5444 74.0205 89.5823 73.7948 89.6579 73.609C89.7336 73.4232 89.8345 73.2772 89.948 73.1711C90.0741 73.0649 90.2128 72.9852 90.3642 72.9322C90.5155 72.8791 90.6669 72.8658 90.8308 72.8658C91.247 72.8658 91.5623 72.9985 91.7767 73.2507C91.9911 73.5029 92.1046 73.8347 92.1046 74.2594C92.1046 74.5248 92.0668 74.7504 91.9785 74.9495C91.8902 75.1486 91.7515 75.3609 91.5623 75.5998L87.6274 80.3911V82.2093H94.0216V80.3911H89.9606L92.8991 76.8076C93.0757 76.582 93.227 76.3829 93.3784 76.1838Z",
    fill: "url(#paint2_linear_241_3984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M101.374 78.7187V76.6616H99.5204V78.7187H97.326L100.933 71.1404H98.8267L95.2324 78.7187V80.6299H99.5204V82.2093H101.374V80.6299H102.333V78.7187H101.374Z",
    fill: "url(#paint3_linear_241_3984)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_241_3984",
    x: 0,
    y: 0,
    width: 162,
    height: 162,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_241_3984"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_241_3984",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_241_3984",
    x1: 33.0282,
    y1: 31.4746,
    x2: 128.444,
    y2: 129.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#201D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_241_3984",
    x1: 105.349,
    y1: 67.4109,
    x2: 120.882,
    y2: 77.3354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEAE2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_241_3984",
    x1: 88.0182,
    y1: 71.0608,
    x2: 96.8678,
    y2: 77.1112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEAE2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_241_3984",
    x1: 95.6663,
    y1: 71.1404,
    x2: 104.766,
    y2: 78.0986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEAE2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D062"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegLogo);
export default __webpack_public_path__ + "static/media/reg_logo.ee55bb8f23342f64bc80d8f517698aef.svg";
export { ForwardRef as ReactComponent };